export default "__VITE_ASSET__DQg9SOYj__"